var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-btn',{staticClass:"secondary-neon-button",attrs:{"flat":""},on:{"click":_vm.claimWeddingGifts}},[_vm._v("\n    claim wedding gifts\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }